import React, { useCallback, useState } from 'react'
import { isBefore, isToday } from 'date-fns'
import dateMask from '@/lib/masks/date'
import PropTypes from 'prop-types'
import { useOnInView } from 'react-intersection-observer'
import { Flexbox, ListManager } from '@/components'
import clinicalCares from '@/services/api/clinicalCares'
import { StickyHeader } from './styles'
import ClinicalCareCard from '../../ClinicalCareCard'

function Day({ clinicId, day, count }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [list, setList] = useState([])

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      const { data } = await clinicalCares.summary(clinicId, day)
      setList(data)
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }, [clinicId, day])

  const trackingRef = useOnInView(
    fetchData,
    {
      triggerOnce: true,
    },
  )

  return (
    <div ref={trackingRef}>
      <StickyHeader>
        <b className={isBefore(new Date(day).setUTCHours(23, 59, 59, 999), new Date()) ? 'text-error' : ''}>
          {isToday(new Date(day).setUTCHours(23, 59, 59, 999))
            ? 'Hoje'
            : dateMask(new Date(day).setUTCHours(23, 59, 59, 999), { dateStyle: 'full' })}
          {isBefore(new Date(day).setUTCHours(23, 59, 59, 999), new Date()) ? '(atrasado)' : ''}
        </b>
        <span className="float-right">
          {count} {count === 1 ? 'atendimento' : 'atendimentos'}
        </span>
      </StickyHeader>

      <ListManager count={list.length} error={error} loading={loading}>
        {
          list.length > 0 && (
            <Flexbox.Columns>
              {
                list.map((clinicalCare) => (
                  <Flexbox.Column className="col-6 col-sm-12 my-2" key={clinicalCare.id}>
                    <ClinicalCareCard clinicalCare={clinicalCare} />
                  </Flexbox.Column>
                ))
              }
            </Flexbox.Columns>
          )
        }
      </ListManager>
    </div>
  )
}

Day.propTypes = {
  day: PropTypes.string.isRequired,
  clinicId: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
}

export default Day
